"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var OrderTable = /** @class */ (function (_super) {
    __extends(OrderTable, _super);
    function OrderTable(props) {
        var _this = _super.call(this, props) || this;
        _this.buildData = function () {
            var _a;
            // if the state.data doesn't exist or is not an array, return an empty array
            if (!Array.isArray((_a = _this.state) === null || _a === void 0 ? void 0 : _a.data)) {
                return [];
            }
            var upperLimit = _this.state.currentPage * _this.state.pageSize;
            var dataSlice = _this.state.data.slice(upperLimit - _this.state.pageSize, upperLimit);
            return dataSlice;
        };
        _this.buildPagination = function () {
            return Array.from(Array(_this.state.pageCount)).map(function (page, i) {
                i++;
                var primary = i === _this.state.currentPage;
                return (React.createElement("div", { key: "" + page + i, className: (primary ? " text-arctic appearance-none border-none outline-none focus:outline-none bg-navy rounded-half" : "") + " flex items-center justify-center text-center  w-3-2 h-3-2  font-bold mx-0-4 inline-block pointer-cursor text-md font-normal", onClick: function () { return _this.setCurrentPage(i); } }, i));
            });
        };
        _this.setCurrentPage = function (page) {
            _this.setState({ currentPage: page });
        };
        _this.state = {
            startPage: 1,
            currentPage: 1,
            pageSize: _this.props.pageSize,
            pageCount: Math.ceil(Math.max(_this.props.data.length / _this.props.pageSize, 1)),
            data: _this.props.data
        };
        return _this;
    }
    OrderTable.prototype.render = function () {
        var _this = this;
        var preview = this.props.preview;
        var withIcon = [
            {
                title: "order",
                width: "15%"
            },
            {
                title: "date",
                width: "25%"
            },
            {
                title: "status",
                width: "20%"
            },
            {
                title: "fullfillment",
                width: "20%"
            },
            {
                title: "total",
                width: "15%"
            },
            {
                title: null,
                width: "5%"
            }
        ];
        var withoutIcon = [
            {
                title: "order",
                width: "15%"
            },
            {
                title: "date",
                width: "25%"
            },
            {
                title: "status",
                width: "25%"
            },
            {
                title: "fullfillment",
                width: "25%"
            },
            {
                title: "total",
                width: "10%"
            }
        ];
        return this.props.isMobile ? (React.createElement("div", { className: "relative mb-10" }, this.props.pagination &&
            this.state.pageCount > 1 &&
            this.buildData().map(function (order, i) { return (React.createElement(Snippets.Card, { key: "" + order.id + i, className: "rounded my-1" },
                React.createElement("a", { className: "flex flex-col text-base cursor-pointer", href: order.customer_url, title: order.name },
                    React.createElement("div", { className: "flex flex-row mb-0-6" },
                        React.createElement("div", { className: "w-1/2 uppercase font-semibold text-navy-dark" }, "Order"),
                        React.createElement("div", { className: "w-1/2" }, order.name)),
                    React.createElement("div", { className: "flex flex-row mb-0-6" },
                        React.createElement("div", { className: "w-1/2 uppercase font-semibold text-navy-dark" }, "Date"),
                        React.createElement("div", { className: "w-1/2" }, next_components_1.ShopifyNext.Utils.formatDate(order.created_at, "DD/MM/YYYY"))),
                    React.createElement("div", { className: "flex flex-row mb-0-6" },
                        React.createElement("div", { className: "w-1/2 uppercase font-semibold text-navy-dark" }, "status"),
                        React.createElement("div", { className: "w-1/2" }, order.financial_status_label)),
                    React.createElement("div", { className: "flex flex-row mb-0-6" },
                        React.createElement("div", { className: "w-1/2 uppercase font-semibold text-navy-dark" }, "fullfillment"),
                        React.createElement("div", { className: "w-1/2" }, order.fulfillment_status_label)),
                    React.createElement("div", { className: "flex flex-row mb-0-6" },
                        React.createElement("div", { className: "w-1/2 uppercase font-semibold text-navy-dark" }, "total"),
                        React.createElement("div", { className: "w-1/2" }, next_components_1.ShopifyNext.Utils.formatMoney(order.total_price)))),
                _this.props.pagination && _this.state.pageCount > 1 && (React.createElement("div", { className: "absolute w-full mb-0 text-navy flex justify-center items-center text-navy-dark transform-x", style: { bottom: -90 } },
                    React.createElement("button", { className: "inline-block cursor-pointer mr-2-4 " + (_this.state.currentPage === 1 ? "text-secondary-blue-grey" : ""), onClick: function () { return _this.setCurrentPage(_this.state.currentPage - 1); }, disabled: _this.state.currentPage === 1 },
                        React.createElement(Snippets.Svg, { name: "chevron-left", width: 16, height: 16 })),
                    _this.buildPagination(),
                    React.createElement("button", { className: "inline-block cursor-pointer ml-2-4 " + (_this.state.currentPage === _this.state.pageCount ? "text-secondary-blue-grey" : ""), onClick: function () { return _this.setCurrentPage(_this.state.currentPage + 1); }, disabled: _this.state.currentPage === _this.state.pageCount },
                        React.createElement(Snippets.Svg, { name: "chevron-right", width: 16, height: 16 })))))); }))) : (React.createElement("div", { className: "relative" },
            React.createElement("div", { className: "block" },
                React.createElement(Snippets.AccountTable, { headers: preview ? withIcon : withoutIcon }),
                this.buildData().map(function (order, i) { return (React.createElement(Snippets.OrderTableTr, { key: "" + order.id + i, order: order, preview: preview, width: preview ? withIcon : withoutIcon })); })),
            this.props.pagination && this.state.pageCount > 1 && (React.createElement("div", { className: "absolute mb-0 text-navy flex justify-center items-center text-navy-dark", style: { bottom: -90 } },
                React.createElement("button", { className: "inline-block cursor-pointer mr-2-4 " + (this.state.currentPage === 1 ? "text-secondary-blue-grey" : ""), onClick: function () { return _this.setCurrentPage(_this.state.currentPage - 1); }, disabled: this.state.currentPage === 1 },
                    React.createElement(Snippets.Svg, { name: "chevron-left", width: 16, height: 16 })),
                this.buildPagination(),
                React.createElement("button", { className: "inline-block cursor-pointer ml-2-4 " + (this.state.currentPage === this.state.pageCount ? "text-secondary-blue-grey" : ""), onClick: function () { return _this.setCurrentPage(_this.state.currentPage + 1); }, disabled: this.state.currentPage === this.state.pageCount },
                    React.createElement(Snippets.Svg, { name: "chevron-right", width: 16, height: 16 }))))));
    };
    OrderTable.contextType = next_components_1.ShopifyNext.Context;
    return OrderTable;
}(React.PureComponent));
exports.OrderTable = OrderTable;
